module.exports = __webpack_public_path__ + "img/H00080.f50b37f2.png";